import { render, staticRenderFns } from "./RoundCounter.vue?vue&type=template&id=4ecdf7eb"
import script from "./RoundCounter.vue?vue&type=script&lang=js"
export * from "./RoundCounter.vue?vue&type=script&lang=js"
import style0 from "./RoundCounter.vue?vue&type=style&index=0&id=4ecdf7eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports